import update from 'immutability-helper';

export default function selectFeature(state, action) {
  //  console.log('SELECT_FEATURE...', action)
  let selectedIndex;
  // iterate the filtered features adding and removing the selected flag.
  for (let [index, feature] of state.feedData.entries()) {
    let flag = false;

    if (feature.id == action.id) {
      selectedIndex = index;
      flag = true;
    }

    state = update(state, {
      feedData: {
        [index]: {
          _selected: {
            $set: flag,
          },
        },
      },
    });
  }

  return update(state, {
    feedDataSelectedIndex: {
      $set: selectedIndex,
    },
  });
}
